/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/Meeting';
export default {
  date: 'Date',
  time: 'Heure',
  hours: '{howMany} h',
  minutes: '{howMany} min',
  today: 'Aujourd’hui',
  duration: 'Durée',
  topic: 'Titre de la réunion',
  voIPOnly: 'Audio sur Internet uniquement',
  telephonyOnly: 'Téléphone uniquement',
  both: 'Téléphone et audio sur Internet',
  thirdParty: 'Audio tiers',
  meetingId: 'ID de réunion',
  password: 'Mot de passe',
  video: 'Vidéo',
  audio: 'Audio',
  scheduleFor: 'Planifier au nom de',
  [ASSISTED_USERS_MYSELF]: 'Moi-même',
  meetingOptions: 'Options de réunion',
  meetingSettings: 'Paramètres de la réunion',
  rcMeetingSettings: 'Paramètres de la visioconférence',
  audioOptions: 'Options audio',
  recurringMeeting: 'Réunion périodique',
  recurringNote:
    'Remarque : activez celle-ci lorsque vous sélectionnez « Récurrence ».',
  joinBeforeHost: 'Autoriser les participants à se connecter avant l’hôte',
  turnOffCamera: 'Désactiver la caméra pour les participants',
  turnOffHostCamera:
    'Désactiver la caméra pour l’hôte lorsque vous rejoignez une réunion',
  requirePassword: 'Exiger un mot de passe',
  enterPassword: 'Entrer le mot de passe',
  setPassword: 'Définir un mot de passe *',
  passwordEmptyError: 'Mot de passe de la réunion requis',
  rcmPasswordInvalidError:
    'Votre mot de passe doit être composé de 1 à 10 lettres et chiffres et ne peut pas comporter de symboles autres que @, * ou -',
  rcmPasswordHintText:
    'Votre mot de passe doit être composé de 1 à 10 lettres et chiffres et ne peut pas comporter de symboles autres que @, * ou -',
  usePersonalMeetingId: 'Utiliser l’ID de réunion personnel',
  pmiChangeConfirm:
    'Si vous souhaitez apporter des modifications à votre réunion personnelle, ',
  changePmiSettings: 'modifiez les paramètres PMI',
  pmiSettingChangeAlert:
    'Si vous modifiez les paramètres et programmez la réunion, toutes les réunions avec ID personnel de réunion utiliseront ces mêmes paramètres.',
  lockedTooltip:
    'Ce paramètre est géré par l’administrateur de votre entreprise',
  when: 'Date',
  recurringDescribe:
    'N’oubliez pas de vérifier dans votre calendrier la périodicité ou les répétitions de vos invitations envoyées aux participants.',
} as const;

// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"time"@#@ @source: @#@"Time"@#@
// @key: @#@"hours"@#@ @source: @#@"{howMany} hr"@#@
// @key: @#@"minutes"@#@ @source: @#@"{howMany} min"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"voIPOnly"@#@ @source: @#@"Internet audio only"@#@
// @key: @#@"telephonyOnly"@#@ @source: @#@"Telephone only"@#@
// @key: @#@"both"@#@ @source: @#@"Telephone and Internet audio"@#@
// @key: @#@"thirdParty"@#@ @source: @#@"3rd party audio"@#@
// @key: @#@"meetingId"@#@ @source: @#@"Meeting ID"@#@
// @key: @#@"password"@#@ @source: @#@"Password"@#@
// @key: @#@"video"@#@ @source: @#@"Video"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"meetingOptions"@#@ @source: @#@"Meeting options"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"rcMeetingSettings"@#@ @source: @#@"Video Meeting settings"@#@
// @key: @#@"audioOptions"@#@ @source: @#@"Audio options"@#@
// @key: @#@"recurringMeeting"@#@ @source: @#@"Recurring meeting"@#@
// @key: @#@"recurringNote"@#@ @source: @#@"Note: Enable this one when choosing \"Recurrence\""@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"turnOffHostCamera"@#@ @source: @#@"Turn off camera for host when joining meeting"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"rcmPasswordInvalidError"@#@ @source: @#@"Your password must be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"rcmPasswordHintText"@#@ @source: @#@"Your password should be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"pmiChangeConfirm"@#@ @source: @#@"If you want to make changes for your Personal Meeting, "@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"change PMI settings"@#@
// @key: @#@"pmiSettingChangeAlert"@#@ @source: @#@"If you change the settings and schedule this meeting, all of meetings with Personal Meeting ID will use the same latest settings."@#@
// @key: @#@"lockedTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"when"@#@ @source: @#@"When"@#@
// @key: @#@"recurringDescribe"@#@ @source: @#@"Please remember to check recurrence or repeat in your calendar invitation to your attendees."@#@
